import React from "react";
import Button, { ButtonModeE } from "../../components/Button/Button";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectFindCampaignStep } from "../../store/selectors/appSelectors";
import { setFindCampaignStep } from "../../store/slices/appSlice";

import styles from "./styles.module.scss";

const FindCampaignFooter = () => {
  const findCampaignStep = useAppSelector(selectFindCampaignStep);
  const dispatch = useAppDispatch();

  const handleSearchAgain = () => {
    dispatch(setFindCampaignStep(1));
  };

  return (
    <div className={styles.footer}>
      {findCampaignStep === 1 && (
        <>
          <span />
          <Button form="find-campaign">Find campaign</Button>
        </>
      )}
      {findCampaignStep === 2 && (
        <>
          <div></div>
          <Button onClick={handleSearchAgain} mode={ButtonModeE.OUTLINED}>
            Search again
          </Button>
        </>
      )}
    </div>
  );
};

export default FindCampaignFooter;
